import {PageSettings} from '../../model/page-settings.model';
import * as MaintenanceOfferActions from '../maintenance-offers/maintenance-offer.actions';


export interface State {
  offers: OfferMaintenanceDto;
  searchParams: OfferMaintenanceSearchParams;
  pageSettings: PageSettings;
}

// default values - will be overridden at demand
const defaultPageSettings = new PageSettings();
defaultPageSettings.size = 25;
defaultPageSettings.page = 0;
defaultPageSettings.sort = 'EXPIRATION';
defaultPageSettings.order = 'ASC';
defaultPageSettings.channel = 'ALL_UC';

/**
 * The reducer acts on actions as defined below, and is the only way to update state
 * The JS spread operator for objects ('...') is used to update a given property of our state
 * while leaving the remaining properties of the state unchanged
 */
export function maintenanceOfferReducer(state: State = {
  offers: undefined,
  pageSettings: defaultPageSettings,
  searchParams: {
    types: ['AUCTION', 'BUYNOW'],
    bundling: 'SINGLE',
    channel: 'ALL_UC'} as OfferMaintenanceSearchParams
},
action: MaintenanceOfferActions.MaintenanceOfferAction) {
  switch (action.type) {
  case MaintenanceOfferActions.UPDATED_OFFERS:
    return {
      ...state,
      offers: action.payload
    };
  case MaintenanceOfferActions.UPDATE_PAGE_SETTINGS:
    return {
      ...state,
      pageSettings: action.payload
    };
  case MaintenanceOfferActions.UPDATE_PAGE_SETTINGS_PAGE:
    return {
      ...state,
      pageSettings: {
        ...state.pageSettings,
        page: action.page
      }
    };
  case MaintenanceOfferActions.UPDATE_SEARCH_PARAMS:
    return {
      ...state,
      searchParams: action.payload
    };
  case MaintenanceOfferActions.DELETE_SEARCH_PARAMS:
    return {
      ...state,
      searchParams: {} as OfferMaintenanceSearchParams
    };
  default:
    return state;
  }
}
